import React, { useEffect } from 'react'
import "magnific-popup";
import $ from "jquery";

import 'animate.css';


const Banner = () => {
  useEffect(() => {
    if ($('.popup-video').length)
    {
    $('.popup-video').magnificPopup({
      type: 'iframe'
    });
  }

  }, [])


  return (
    <section className="banner-area banner-bg" style={{ backgroundImage: 'url("../img/banner/white-logo-with-black-bg2.png")' }}>
      <div className="container custom-container">
        <div className="row">
          <div className="col-xl-6 col-lg-8">

            <div className="banner-content ">
              <h4 className="sub-title animate__animated animate__fadeInUp" data-wow-delay=".2s" data-wow-duration="1.8s">Welcome to</h4>
              <h2 className="title animate__animated animate__fadeInUp" data-wow-delay=".4s" data-wow-duration="1.8s">Satrang Media & Production </h2>
              <div className="banner-meta animate__animated animate__fadeInUp" data-wow-delay=".6s" data-wow-duration="1.8s">
                <p className="sub-title animate__animated animate__fadeInUp" data-wow-delay=".2s" data-wow-duration="1.8s">Our Vision. Our Passion & Infinite Possibilities </p>
              </div>
              {/* Commenting it until an updated video is received from production team 
              <a href="https://www.youtube.com/watch?v=AvgNyz_Ir9A" className="banner-btn btn popup-video wow fadeInUp" data-wow-delay=".8s" data-wow-duration="1.8s"><i className="fas fa-play" /> Watch Us</a>*/}
            </div>

          </div>
        </div>
      </div>
    </section>
  )
}

export default Banner